<!-- @format -->

<template>
	<pcp-selector-dialog
		:value="selectedValue"
		:visible="selectorVisible"
		:title="title"
		:width="width"
		margin-top="15vh"
		:class="className"
		:label-key="labelKey"
		:multiple="multiple"
		@input-main="(value) => (selectedValue = value)"
		@fullscreen="handleFullscreen"
		@open="handleOpen"
		@opened="handleOpened"
		@remove-select="setSelectRow"
		@close="handleClose"
		@action-event="handleActionEvent"
	>
		<template #default="scope">
			<pcp-selector-panel
				v-if="selectorVisible"
				ref="panel"
				v-bind="scope"
				:height="actualHeight"
				:party-type-id="partyTypeId"
				:seeting-search-party-type="seetingSearchPartyType"
				:current-org-id="currentOrgId"
				:external-use-id="externalUseId"
				:script="script"
				:form-data="formData"
				:pk-key="store === 'bind' ? 'name' : 'id'"
				:is-super-init-tree="isSuperInitTree"
				:show-tree="showTree"
				:options="options"
				:has-subset="hasSubset"
				:is-use-scope="isUseScope"
				:party-type-scope="partyTypeScope"
				:custom-party-type-options="customPartyTypeOptions"
				:user-range="userRange"
				@selected="(value) => (selectedValue = value)"
				@change-party-type="changePartyType"
			/>
		</template>
	</pcp-selector-dialog>
</template>
<script>
	import PcpSelectorPanel from './panel';
	import PcpSelectorDialog from '@/p-components/pcp-selector-dialog/dialog';
	import { $utils } from '@/utils/publicUtils';

	export default {
		components: {
			PcpSelectorDialog,
			PcpSelectorPanel,
		},
		props: {
			formData: [Object, Array], // 所有字段数据,(包含主主子表)
			className: String,
			labelKey: {
				// 展示的值
				type: [String, Function],
				default: 'name',
			},
			store: {
				type: String,
				default: 'id',
			},
			filter: {
				type: Array,
				default: () => [],
			},
			isUseScope: {
				// 是否启用范围
				type: Boolean,
				default: false,
			},
			hasSubset: {
				// 是否包含子集
				type: Boolean,
				default: false,
			},
			partyTypeScope: String,
			visible: Boolean, // 是否可见
			seetingSearchPartyType: String,
			script: String,
			partyTypeId: [String, Number],
			currentOrgId: {
				type: [String, Number],
				default: '',
			},
			// 外部用户id，上下级使用
			externalUseId: [String, Number],
			showTree: {
				type: Boolean,
				default: true,
			},
			customPartyTypeOptions: [Object, Array],
			title: {
				// 标题
				type: String,
				default() {
					return '用户选择器';
				},
			},
			marginTop: {
				// Dialog CSS 中的 margin-top 值
				type: String,
				default: '15vh',
			},
			width: {
				// 宽
				type: String,
				default: '60%',
			},
			height: {
				// 高
				type: String,
				default: '345px',
			},
			closeOnClickModal: {
				// 是否可以通过点击 modal 关闭 Dialog
				type: Boolean,
				default: false,
			},
			closeOnPressEscape: {
				// 是否可以通过按下 ESC 关闭 Dialog
				type: Boolean,
				default: false,
			},
			showClose: {
				// 是否显示关闭按钮
				type: Boolean,
				default: true,
			},
			beforeClose: {
				// 关闭前的回调，会暂停 Dialog 的关闭
				type: Function,
			},
			fullscreen: {
				// 是否为全屏 Dialog
				type: Boolean,
				default: false,
			},
			valueKey: {
				// 唯一存储的值
				type: String,
				default: 'id',
			},
			value: {
				type: [Object, Array],
				default: () => {
					// return this.multiple ? [] : {};
				},
			},
			cleanClose: {
				// 按钮清空并关闭
				type: Boolean,
				default: false,
			},
			isSuperInitTree: Object,
			buttons: {
				// 按钮组
				type: Array,
			},
			confirmButtonText: {
				type: String,
				default() {
					return '确认';
				},
			},
			cleanButtonText: String,
			cancelButtonText: String,
			multiple: {
				// 是否多选
				type: Boolean,
				default: false,
			},
			// 额外配置
			options: {
				type: Object,
				default: () => {},
			},
			userRange: {
				type: Object,
				default: () => {},
			},
		},
		data() {
			return {
				selectorVisible: false,
				selectedValue: this.multiple ? [] : {},
				dialogFullscreen: this.fullscreen,
				that: this,
			};
		},
		computed: {
			actualHeight() {
				return this.dialogFullscreen ? this.getFullscreenDialogHeight() : this.height;
			},
		},
		watch: {
			visible: {
				handler(val) {
					this.selectorVisible = val;
					this.selectedValue = this.getInitSelectdValue();
				},
				immediate: true,
			},
			fullscreen(val) {
				this.dialogFullscreen = val;
			},
		},
		beforeUnmount() {
			this.selectedValue = null;
		},
		methods: {
			getFullscreenDialogHeight() {
				const h = document.documentElement.clientHeight || document.body.clientHeight;
				return `${h - 60 - 90}px`;
			},
			getInitSelectdValue() {
				if (this.store === 'bind') {
					if ($utils.isEmpty(this.value)) {
						return this.multiple ? [] : {};
					}
					this.value.map((v) => {
						const name = $utils.isString(v) ? v : v[this.valueKey];
						const data = {};
						data[this.valueKey] = name;
						return data;
					});
				} else {
					return this.value;
				}
			},
			setSelectRow() {
				this.$refs.panel.setSelectRow();
			},
			handleFullscreen(val) {
				this.dialogFullscreen = val;
			},
			// 打开窗口
			handleOpen() {
				this.$emit('open');
			},
			// 打开窗口后
			handleOpened() {
				this.$emit('opened');
			},
			handleClose(visible) {
				this.$emit('close', visible);
			},
			handleActionEvent(key) {
				if (key === 'clean') {
					this.setSelectRow();
				}
				if (key === 'cancel') {
					this.selectedValue = [];
				}
				// 备注: 注释掉是因为外部回调事件会走两次
				// this.$emit('action-event', key, data);
			},
			changePartyType(value) {
				this.$emit('change-party-type', value);
			},
		},
	};
</script>
